/* eslint-disable @typescript-eslint/naming-convention */

import { BankData } from '@formunauts/banking/domain';

import * as AT from './banks/at.banks.json';
import * as CH from './banks/ch.banks.json';
import * as DE from './banks/de.banks.json';
import * as GB from './banks/gb.banks.json';

export interface BankRegistry {
  [k: string]: BankData;
}

/**
 * A registry, that lists banks for the country identified with
 * the given ISO country identifier
 */
export const banks: BankRegistry = {
  AT: AT as BankData,
  CH: CH as BankData,
  DE: DE as BankData,
  GB: GB as BankData,
};
